import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-recu-bn-recep',
  templateUrl: './recu-bn-recep.component.html',
  styleUrls: ['./recu-bn-recep.component.scss']
})
export class RecuBnRecepComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        console.log('ReçuCmdComponent initialized');
        this.dataService.filterBonReceptionByStatus('Reçu');

    }

}
